module.exports = __webpack_public_path__ + "84a805150ff19f55a13224f3460d895b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-clover-s.png
// module id = 1817
// module chunks = 0